import jQuery from 'jquery';

import 'bootstrap';
import fee from './fee';
import helpers from './helpers';

window.$ = jQuery;
window.jQuery = jQuery;
global.$ = jQuery;
global.jQuery = jQuery;

$(() => {
  function getBidLevel(bid, vehicleType) {
    let levels = [
      {
        startAmount: 50001,
        minimumBid: 500,
      },
      {
        startAmount: 25001,
        minimumBid: 250,
      },
      {
        startAmount: 15001,
        minimumBid: 150,
      },
      {
        startAmount: 5001,
        minimumBid: 100,
      },
      {
        startAmount: 1001,
        minimumBid: 50,
      },
      {
        startAmount: 0,
        minimumBid: 25,
      },
    ];

    if (vehicleType === 'car' || vehicleType === 'recreation') {
      levels = [
        {
          startAmount: 1000,
          minimumBid: 100,
        },
        {
          startAmount: 0,
          minimumBid: 25,
        },
      ];
    }
    const count = levels.length;
    let level = levels[count - 1];

    for (let i = 0; i < count; i += 1) {
      if (bid >= levels[i].startAmount) {
        level = levels[i];
        break;
      }
    }

    return level;
  }

  function parseBidInput(value) {
    const digits = value.replace(/\D/g, '');

    return parseInt(digits, 10) || 0;
  }

  /**
     * Find each bidForm there is and bind handlers to change the input and
     * show feedback to the user.
     */
  $('form.bidForm').each((index, element) => {
    const $form = $(element);
    const $bidInput = $form.find('input[name="bidValue"]');
    const originalBid = parseBidInput($form.find('input.original').val());
    const vehicleType = $bidInput.data('vehicle-type');
    let { minimumBid } = getBidLevel(originalBid, vehicleType);
    let inputHasFocus = false;

    function getInputValue() {
      return parseBidInput($bidInput.val());
    }

    function setInputValue(bid, useMoneyFormat) {
      let displayValue = bid;

      if (useMoneyFormat) {
        displayValue = helpers.formatAmount(bid);
      }

      // Render new value.
      $bidInput.val(displayValue);
    }

    function validateBid(bid) {
      const isValid = (bid === originalBid) || (bid >= originalBid + minimumBid);

      // Update style.
      $bidInput.parent('.input-group').toggleClass('has-error', isValid === false);

      return isValid;
    }

    function updateBid(bid, useAutoCorrect) {
      const getHandlingFee = !!document.getElementById('bid');
      let newBid = bid;
      if (bid === 0) {
        newBid = originalBid;
      }

      if (useAutoCorrect === true) {
        if (newBid <= originalBid) {
          // Not below original bid.
          newBid = originalBid;
        } else if (newBid - minimumBid < originalBid + minimumBid) {
          newBid = originalBid + minimumBid;
        }
      }

      if ((vehicleType === 'car' || vehicleType === 'recreation') && newBid >= 1000) {
        // We only want rounded bids above 1000
        newBid = Math.round(newBid / 100) * 100;
      }

      // Show input validation status.
      validateBid(newBid);

      // Use money format when not focussed.
      setInputValue(newBid, inputHasFocus === false);

      if (getHandlingFee) {
        // Update handling fee.
        fee.getHandlingfee(vehicleType);
      }
    }

    function bidStepUp() {
      let bid = getInputValue();
      if (vehicleType === 'car' || vehicleType === 'recreation') {
        const bidLevel = getBidLevel(bid, vehicleType);
        minimumBid = bidLevel.minimumBid;
      }

      if (bid < minimumBid) {
        bid = minimumBid;
      } else {
        bid += minimumBid;
      }

      // With auto correction.
      updateBid(bid, true);
    }

    function bidStepDown() {
      const bid = getInputValue() - minimumBid;
      if (vehicleType === 'car' || vehicleType === 'recreation') {
        const bidLevel = getBidLevel(bid, vehicleType);
        minimumBid = bidLevel.minimumBid;
        if (bid === 1000 && minimumBid === 100) {
          minimumBid = 25;
        }
      }

      // With auto correction.
      updateBid(bid, true);
    }

    $bidInput.on('keydown', (event) => {
      switch (event.keyCode) {
        case 38: // Arrow up.
          bidStepUp();
          break;
        case 40: // Arrow down.
          bidStepDown();
          break;
        default:
      }
    });

    $bidInput.on('keyup mouseup change', (event) => {
      if (event.key === 'Escape') {
        // Escape triggers blur and resets the field.
        $bidInput.trigger('blur');
        return;
      }

      // Show input status.
      validateBid(getInputValue());
    });

    $bidInput.on('focus', () => {
      inputHasFocus = true;

      /* Do not show any value for zero - DEV-2776 */
      let inputValue = getInputValue();
      if (inputValue === 0) {
        inputValue = '';
      }

      // Render without money format.
      setInputValue(inputValue, false);
    });

    $bidInput.on('blur', () => {
      inputHasFocus = false;

      // After leaving the field, use current value.
      updateBid(getInputValue());
    });

    $form.find('.plus, .detailBtnPlus').on('click', (event) => {
      bidStepUp();

      event.stopPropagation();
      return false;
    });

    $form.find('.minus, .detailBtnMinus').on('click', (event) => {
      bidStepDown();

      event.stopPropagation();
      return false;
    });

    // Stop autocompletion.
    $bidInput.attr('autocomplete', 'off');
  });

  // Initialize each selector.
  $('.selector').each((index, instance) => {
    // Set jQuery references.
    const $instance = $(instance);
    const $select = $instance.find('> select:first');
    const $input = $instance.find('> input:first');

    // Update function.
    const updateInputValue = () => {
      // Update input element...
      $input.val(
        // Grab array from select2 selection object.
        $select.select2('data')
        // Map entries to array with ids.
          .map((option) => option.id)
        // Join to string by comma.
          .join(','),
      );
    };

    // Init select2.
    $select.select2({
      placeholder: $select.attr('placeholder'),
      language: $select.attr('lang'),
      width: '100%',
      height: '33px',
    });

    // Update input value on startup.
    updateInputValue();

    // Show after initializing plugin.
    $instance.css('display', 'block');

    // On selecting options.
    $select.on('select2:select', updateInputValue);

    // On updating available options.
    $select.on('change', updateInputValue);
  });
});

window.setTimeout(() => {
  $('.alert:not(.keep)').alert('close');
}, 10000);
